<template>
  <div>
    <el-radio-group v-model="$store.state.user.projectCode" @change="change">
      <el-radio-button v-for="item in projectList" :key="item.value" :label="item.value">{{item.label}}</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
import {getProjectList} from '@/com.js';
import {projectConfigDetail} from '@/utils/projectConfig.js';

export default {
  data() {
    this.projectList = getProjectList();
    this.firstCode = this.projectList.length ? this.projectList[0].value : projectConfigDetail.code;
    return {};
  },
  computed: {
    projectCode() {
      return this.$store.state.user.projectCode;
    }
  },
  activated() {
    this.initCode();
  },
  mounted() {
    this.initCode();
  },
  methods: {
    initCode() {
      if (this.firstCode !== this.projectCode) this.$store.commit('user/SET_PROJECT_CODE', this.firstCode);
    },
    change(val) {
      this.$store.commit('user/SET_PROJECT_CODE', val);
      this.$emit('change', val);
    }
  }
}
</script>